export const contentType = {
  multipartFormData: 'multipart/form-data',
};

export const requestHeaders = {
  contentType: value => ({ 'Content-Type': value }),
};
